export const capitalizeAndSpace = (str: string) => {
    if (typeof str !== 'string') {
      return str; 
    }
    return str
      .split(" ")
      .map(word => word.charAt(0).toUpperCase() + word.slice(1))
      .join(" ")
      .replace(/([A-Z])/g, ' $1')
      .trim();
  };
  
  export const formatWord = (str: string) => {
    if (typeof str !== 'string') {
      return str;
    }
    return str
      .replace(/_/g, " ") // Replace underscores with spaces
      .split(" ") // Split by space to capitalize each word
      .map(word => word.charAt(0).toUpperCase() + word.slice(1)) // Capitalize the first letter
      .join(" "); // Join the words back together
  };
  
    //Oct 10 2024
    export const formatDate = (dateString: string) => {
      const date = new Date(dateString);
    
      // Check if the date is valid
      if (isNaN(date.getTime())) {
        return "Invalid date";
      }
    
      return new Intl.DateTimeFormat('en-US', {
        month: 'short',
        day: 'numeric',
        year: 'numeric'
      }).format(date);
    };
    
    // replace _ and make first letter as capital...
   export  const replaceUndersocreAndFormat = (type: string) => {
      return type.replace(/[_-]/g, ' ').replace(/\b\w/g, (char) => char.toUpperCase());
    };
    
    export function formatTime(timestamp:any) {
      const date = new Date(timestamp);
      let hours = date.getHours();
      const minutes = date.getMinutes();
      const ampm = hours >= 12 ? 'PM' : 'AM';
    
      // Handle 12-hour conversion
      hours = hours === 0 ? 12 : hours > 12 ? hours - 12 : hours;
    
      const formattedMinutes = minutes.toString().padStart(2, '0'); // Ensure two digits
      return `${hours}:${formattedMinutes} ${ampm}`;
    }


    export const formatDateAndTime = (dateStr:any) => {
  const date = new Date(dateStr);
  const options:any = { 
    month: 'short', 
    day: '2-digit', 
    year: 'numeric',
  };
  return `${date.toLocaleDateString('en-US', options)} | ${date.toLocaleTimeString('en-US', { hour: '2-digit', minute: '2-digit', hour12: true })}`;
};
    